export function getNumericResponseLabel(
  val: number | string,
  actionType: string,
  t: (key: string, params?: Record<string, string | number>) => string,
): string {
  const numVal = Number(val)

  if (numVal === -1) {
    if (actionType === 'action_run_for_sheriff') {
      return t('game.sheriffDoNotRun')
    }
    if (actionType === 'action_sheriff_campaign') {
      return t('game.sheriffStayInRace')
    }
    if (actionType === 'action_sheriff_decide_order') {
      return t('game.sheriffKeepDefaultOrder')
    }
    if (actionType === 'action_sheriff_transfer_badge') {
      return t('game.sheriffTearBadge')
    }
    if (actionType === 'action_werewolf_explode' || actionType === 'action_alpha_wolf_fire') {
      return t('game.notExplode')
    }
    if (actionType === 'action_moron_flip') {
      return t('game.moronDecline')
    }
    if (actionType === 'action_vote') {
      return t('game.voteAbstain')
    }
    return t('game.skipNoAction')
  }

  if (actionType === 'action_run_for_sheriff' && numVal === 0) {
    return t('game.sheriffRun')
  }

  if (actionType === 'action_sheriff_campaign' && numVal === 0) {
    return t('game.sheriffWithdraw')
  }

  if (actionType === 'action_moron_flip' && typeof numVal === 'number' && numVal > 0) {
    return t('game.moronFlip')
  }

  if (actionType === 'action_werewolf_explode' && typeof numVal === 'number' && numVal > 0) {
    return t('game.explode')
  }

  if (actionType === 'action_alpha_wolf_fire' && typeof numVal === 'number' && numVal > 0) {
    return t('game.seat', { num: numVal })
  }

  if (typeof numVal === 'number' && numVal > 0) {
    return t('game.seat', { num: numVal })
  }

  return String(val)
}
